__turbopack_context__.v({
  "authButtonsContainer": "AuthButtons-module__J7uTZq__authButtonsContainer",
  "signButton": "AuthButtons-module__J7uTZq__signButton",
});
